import { VpActionChip, VpIcon } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { MAX_COLUMNS, MIN_COLUMNS } from '@/contexts/products/ProductsContext'
import { useProductsContext } from '@/contexts/products/useProductsContext'
import { ANALYTICS_EVENTS, trackAnalyticsEvent } from '@/services/analytics'

export function ProductsViewHeaderZoomControls() {
  const { t } = useTranslation()
  const { season } = useParams<{ season: string }>()
  const { columns, viewMode, zoomIn, zoomOut } = useProductsContext()

  const handleZoom = (action: 'in' | 'out') => {
    const nextZoomLevel = action === 'in' ? Math.max(MIN_COLUMNS, columns - 1) : Math.min(MAX_COLUMNS, columns + 1)

    if (nextZoomLevel === columns)
      return

    trackAnalyticsEvent(ANALYTICS_EVENTS.PRODUCT_GALLERY_ZOOM_CHANGED, {
      zoom_level: nextZoomLevel,
      zoom_action: action,
      season,
      view_mode: viewMode,
    })

    if (action === 'in') {
      zoomIn()
      return
    }

    zoomOut()
  }

  return (
    <div className="products-view-header__zoom-controls">
      <VpActionChip
        aria-label={t('aria-label.products-gallery-zoom-in')}
        size="small"
        className="products-view-header__zoom-plus"
        onClick={() => handleZoom('in')}
        disabled={columns === MIN_COLUMNS}
      >
        <VpIcon name="zoom-in" />
      </VpActionChip>
      <VpActionChip
        aria-label={t('aria-label.products-gallery-zoom-out')}
        size="small"
        className="products-view-header__zoom-minus"
        onClick={() => handleZoom('out')}
        disabled={columns === MAX_COLUMNS}
      >
        <VpIcon name="zoom-out" />
      </VpActionChip>
    </div>
  )
}
